module.exports = __webpack_public_path__ + "img/ico226.4887fbde.svg";